import LoanProductPage from '@/pages/loan/components/LoanProductPage';

export default function EnterprisePage() {
  return <LoanProductPage slug="enterprise" />;
}